<template>
  <div>
    <model-list-in-modal
      v-if="models_modal_open"
      :threshold="threshold"
      @close_modal="hide_models_modal"
      @models-changed="onModelsChanged"
      :models="models"
    ></model-list-in-modal>
    <confusion-matrix-in-modal v-if="model_confusion_matrix_in_modal" @close_modal="hide_confusion_matrix_modal" :model="model_confusion_matrix_in_modal"></confusion-matrix-in-modal>
    <model-performance-chip @click="show_confusion_matrix_modal(model)" v-for="model in filtered_models" :threshold="threshold" :model="model" :key="`${model.id}-${threshold}`"></model-performance-chip>
    <v-btn icon v-if="filtered_models.length > 0" @click="show_models_modal()" color="primary" x-small class="ml-2">
        <v-icon>fa-solid fa-list</v-icon>
    </v-btn>
    <v-btn
      v-for="job in jobsWithTrainLog"
      :key="'train-log-' + job.id"
      icon
      color="primary"
      x-small
      class="ml-1"
      :title="$t('models_and_train_configs.train_log_title')"
      @click="openTrainLog(job)"
    >
      <v-icon>fas fa-chart-line</v-icon>
    </v-btn>
    <train-log-modal
      v-if="trainLogJob"
      :job="trainLogJob"
      :model="trainLogModel"
      @close="closeTrainLog"
    />
  </div>
</template>

<script>
import ModelPerformanceChip from "@/components/models/ModelPerformanceChip";
import ModelListInModal from "@/components/models/ModelListInModal";
import ConfusionMatrixInModal from "@/components/models/ConfusionMatrixInModal";
import TrainLogModal from "@/components/models/TrainLogModal";
import { jobHasTrainMetrics, parseJobDescription } from "@/utils/trainMetrics";
import dayjs from "dayjs";

export default {
  name: "ModelPerformanceSummary",
  components: {ModelListInModal, ModelPerformanceChip, ConfusionMatrixInModal, TrainLogModal},
  data () {
    return {
      models_modal_open: false,
      'model_confusion_matrix_in_modal': null,
      trainLogJob: null,
      trainLogModel: null,
    }
  },
  computed: {
    sorted_models () {
      let models = JSON.parse(JSON.stringify(this.models));
      models.sort(this.compare_created_at)
      return models;
    },
    filtered_models () {
      return this.sorted_models.slice(0, 3);
    },
    jobsWithTrainLog() {
      return (this.related_jobs || []).filter(jobHasTrainMetrics);
    },
  },
  methods: {
    closeTrainLog() {
      this.trainLogJob = null;
      this.trainLogModel = null;
    },
    openTrainLog(job) {
      this.trainLogJob = job;
      const desc = parseJobDescription(job);
      const modelId = desc.model_id ?? job.model_id;
      if (modelId != null) {
        const model = this.models.find(
          (m) => Number(m.id) === Number(modelId),
        );
        if (model) {
          this.trainLogModel = model;
          return;
        }
      }
      const tcId = desc.train_config_id;
      if (tcId == null) {
        this.trainLogModel = null;
        return;
      }
      const same = this.models.filter(
        (m) => Number(m.train_config_id) === Number(tcId),
      );
      if (!same.length) {
        this.trainLogModel = null;
        return;
      }
      same.sort(
        (a, b) => dayjs(b.created_at).unix() - dayjs(a.created_at).unix(),
      );
      this.trainLogModel = same[0];
    },
    compare_created_at(a, b) {
      return dayjs(b.created_at).unix() - dayjs(a.created_at).unix();
    },
    show_models_modal() {
      this.models_modal_open = true;
    },
    show_confusion_matrix_modal(model) {
      this.model_confusion_matrix_in_modal = model
    },
    hide_models_modal() {
      this.models_modal_open = false;
    },
    onModelsChanged() {
      this.$emit('models-changed');
    },
    hide_confusion_matrix_modal() {
      this.model_confusion_matrix_in_modal = null
    },
  },
  props: {
    models: {required: true},
    related_jobs: {required: true},
    threshold: {required: true}
  },
}
</script>

<style scoped>

</style>
